<phx-alert *ngIf="showErrorBanner" phxAlertType="inline" phxAlertIntent="negative" [phxClosable]="true"
  (phxOnClose)="dismissErrorBanner()" class="phx-file-upload-error-alert">
  <span phx-alert-title>{{ errorBannerTitle }}</span>
  <span phx-alert-content>{{ errorBannerReason }}</span>
</phx-alert>

<!-- Upload Area drop zone (rendered at top for WRAPPED, below the tiles for TILES) -->
<ng-template #dropZone>
  <div [class.phx-file-upload-drop-zone]="showDropZone"
    [class.phx-file-upload-btn-container]="!showDropZone" [class.phx-file-upload-drop-zone-drag-over]="isDragOver"
    (drop)="onDrop($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)">
    <div [class.phx-file-upload-drop-zone-content]="showDropZone">
      <div *ngIf="showDropZone" class="phx-file-upload-drop-zone-text-container">
        <span class="phx-file-upload-drop-zone-title">{{ dropZoneText }}</span>
        <div class="phx-file-upload-drop-zone-subtitle-row">
          <span class="phx-file-upload-drop-zone-subtitle">{{ dropZoneSubtitleFormats }}</span>
          <i phx-icon [size]="16" [phxIcon]="bulletIcon" [color]="'inactive'"></i>
          <span class="phx-file-upload-drop-zone-subtitle">{{ dropZoneSubtitleMaxSize }}</span>
        </div>
      </div>
      <ng-container [ngTemplateOutlet]="uploadButton"></ng-container>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="showDropZone && phxLayout !== PHX_LAYOUT_TYPE.TILES" [ngTemplateOutlet]="dropZone"></ng-container>

<ng-container *ngIf="phxLayout === PHX_LAYOUT_TYPE.WRAPPED && phxFiles.length > 0">
  <!-- File Count (Only shown in Bulk Upload Mode) -->
  <div *ngIf="phxFileBulkUploadMode; else heading" class="phx-file-upload-file-count">
    {{ fileCountText }}
  </div>
  <ng-template #heading>
    <div *ngIf="phxHeading" class="phx-file-upload-heading-container">
      <ng-container *ngTemplateOutlet="phxHeading"></ng-container>
    </div>
  </ng-template>

  <!-- Files container -->
  <div #filesContainer class="phx-file-uploaded-container">
    <div class="phx-file-upload-wrapped" [class.phx-file-upload-wrapped-no-detail]="!phxShowDetails"
      [class.phx-file-upload-edit-wrapped]="phxEditMode">
      <phx-file-item *ngFor="let file of displayFiles; let i = index" [phxFile]="file" [phxIndex]="i"
        [phxIsEditMode]="phxEditMode" [phxObfuscate]="phxObfuscate" [phxShowDetails]="phxShowDetails"
        [phxWidth]="phxThumbnailWidth" [phxHeight]="phxThumbnailHeight" (phxRemoveFile)="onFileRemove($event)"
        (phxRetryUpload)="onFileRetry($event)" (phxPreview)="onFilePreview($event)">
      </phx-file-item>
    </div>
    <ng-container *ngIf="phxSubtext" class="phx-file-upload-subtext">
      <ng-container *ngTemplateOutlet="phxSubtext"></ng-container>
    </ng-container>
  </div>

  <!-- File upload button in non Bulk Upload Mode -->
  <ng-container *ngIf="!showDropZone && showUploadButton" [ngTemplateOutlet]="uploadButton">
  </ng-container>
</ng-container>

<!-- Upload button template -->
<ng-template #uploadButton>
  <ng-container *ngIf="phxUploadButtonTemplate; else defaultUploadButton">
    <ng-container *ngTemplateOutlet="phxUploadButtonTemplate; context: { $implicit: fileInput }"></ng-container>
  </ng-container>
  <ng-template #defaultUploadButton>
    <button type="button" phx-button phxButtonRole="secondary" class="phx-file-upload-browse-button"
      (click)="fileInput.click()">
      <span>{{ uploadButtonText }}</span>
    </button>
  </ng-template>
</ng-template>

<!-- File List - Inline No Detail Layout -->
<div #filesContainer class="phx-file-upload-inline-container" *ngIf="phxLayout === PHX_LAYOUT_TYPE.INLINE_NO_DETAIL">
  <phx-carousel [phxItemsToScroll]="1" [phxItemWidth]="phxThumbnailWidth + 'px'" [phxLeftNavigationTemplate]="navLeft"
    [phxRightNavigationTemplate]="navRight">
    <div phx-carousel-item *ngFor="let file of phxFiles; let i = index; trackBy: trackByFile"  class="phx-file-upload-carousel-item">
      <phx-file-item [phxFile]="file" [phxIndex]="i" [phxIsEditMode]="phxEditMode" [phxObfuscate]="phxObfuscate"
        [phxShowDetails]="false" [phxWidth]="phxThumbnailWidth" [phxHeight]="phxThumbnailHeight"
        [class.phx-file-active]="isActive(file)" phx-tooltip
        [phxTrigger]="(file.status$ | async) === 'error' ? 'hover' : 'none'" [phxContent]="file.errorMessage || ''"
        phxPlacement="top" phxIntent="neutral" phxTooltipSize="small" (phxRemoveFile)="onFileRemove($event)"
        (phxRetryUpload)="onFileRetry($event)" (phxPreview)="onFilePreview($event)">
      </phx-file-item>
    </div>
  </phx-carousel>

  <!-- Add Button -->
  <button *ngIf="phxEditMode" [phxIconButtonSize]="'extra-extra-large'" phx-icon-button type="button"
    class="phx-file-upload-inline-add-button" [phxIcon]="plusIcon" [disabled]="isLimitReached"
    (click)="!isLimitReached && fileInput.click()" (drop)="!isLimitReached && onDrop($event)"
    (dragover)="!isLimitReached && onDragOver($event)" (dragleave)="!isLimitReached && onDragLeave($event)"
    phx-tooltip [phxTrigger]="isLimitReached ? 'hover' : 'none'" [phxContent]="fileLimitText"
    phxPlacement="top" phxIntent="neutral" phxTooltipSize="small"></button>
</div>

<ng-template #navLeft>
  <button type="button" class="phx-file-upload-nav-button phx-file-upload-nav-button-left">
    <i phx-icon [phxIcon]="leftIcon"></i>
  </button>
</ng-template>

<ng-template #navRight>
  <button type="button" class="phx-file-upload-nav-button phx-file-upload-nav-button-right">
    <i phx-icon [phxIcon]="rightIcon"></i>
  </button>
</ng-template>

<!-- File List - Tiles Layout -->
<ng-container *ngIf="phxLayout === PHX_LAYOUT_TYPE.TILES">
  <div class="phx-file-upload-tiles">
    <ng-container *ngFor="let slot of tileSlots; let i = index; trackBy: trackByTileSlot">
      <phx-file-item *ngIf="slot; else tilePlaceholder" [phxFile]="slot" [phxIndex]="i" [phxTileMode]="true"
        [phxIsEditMode]="phxEditMode" [phxShowDetails]="false" [phxObfuscate]="phxObfuscate"
        (phxRemoveFile)="onFileRemove($event)" (phxRetryUpload)="onFileRetry($event)"
        (phxPreview)="onFilePreview($event)"></phx-file-item>
      <ng-template #tilePlaceholder>
        <button type="button" class="phx-file-upload-tile-placeholder"
          (click)="onTileCapture(i)">
          <i phx-icon [phxIcon]="placeholderIcon"></i>
        </button>
      </ng-template>
    </ng-container>
  </div>

  <!-- Validation result banners (driven reactively by each file's status) -->
  <phx-alert *ngIf="showTilesErrorBanner" phxAlertType="inline" phxAlertIntent="negative" [phxHasIcon]="true"
    phxOrientation="vertical" class="phx-file-upload-tiles-banner">
    <span phx-alert-content>{{ tilesErrorTitle }}</span>
    <ul phx-alert-content class="phx-file-upload-tiles-error-list">
      <li *ngFor="let message of tilesErrorMessages">{{ message }}</li>
    </ul>
  </phx-alert>
  <phx-alert *ngIf="showTilesSuccessBanner" phxAlertType="inline" phxAlertIntent="positive" [phxHasIcon]="true"
    class="phx-file-upload-tiles-banner">
    <span phx-alert-content>{{ phxTilesSuccessMessage }}</span>
  </phx-alert>

  <!-- Drop zone stays below the tiles until the limit is reached -->
  <ng-container *ngIf="showDropZone" [ngTemplateOutlet]="dropZone"></ng-container>
</ng-container>

<!-- Hidden File Input -->
<input #fileInput type="file" class="phx-file-upload-input" [accept]="acceptedFileTypes" [multiple]="phxMultiple"
  (change)="onFileInputChange($event)" />

<!-- Image Gallery -->
<phx-gallery [phxImages]="galleryImages" [phxSelectedIndex]="gallerySelectedIndex" [phxEditMode]="phxEditMode"
  (phxDeleteImage)="onGalleryDeleteImage($event)" [(phxOpen)]="isGalleryOpen" (phxRotateImage)="onGalleryRotateImage($event)"></phx-gallery>
